import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=29bb16bc"
import script from "./EndScreen.vue?vue&type=script&lang=ts"
export * from "./EndScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports